import { render } from "./MenuMobile.vue?vue&type=template&id=2b0221c2&scoped=true&ts=true"
import script from "./MenuMobile.vue?vue&type=script&lang=ts"
export * from "./MenuMobile.vue?vue&type=script&lang=ts"

import "./MenuMobile.vue?vue&type=style&index=0&id=2b0221c2&lang=stylus"
import "./MenuMobile.vue?vue&type=style&index=1&id=2b0221c2&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0221c2"]])

export default __exports__